<template>
  <div class="yxtbiz-rule-validity">
    <yxt-radio-group v-model="formData.validType" @change="onChange">
      <yxt-radio :label="1">{{ $t('pc_biz_rule_long_term_validity' /*'长期有效'*/) }}</yxt-radio>
      <yxt-radio :label="2">{{ $t('pc_biz_rule_time_range' /*'指定范围'*/) }}</yxt-radio>
    </yxt-radio-group>
    <div v-if="showTimes" class="mt16">
      <yxt-date-picker
      v-model="formData.validTimes"
      type="daterange"
      value-format="yyyy-MM-dd"
      :range-separator="$t('pc_biz_rule_to' /*至*/)"
      :start-placeholder="$t('pc_biz_rule_start_time' /*开始时间*/)"
      :end-placeholder="$t('pc_biz_rule_end_time' /*结束时间*/)">
    </yxt-date-picker>
    </div>
  </div>
</template>

<script>
import { getRuleBaseInfo } from './service';
export default {
  name: 'YxtbizRuleValidity',
  props: {
    // 业务编号
    businessCode: {
      type: String,
      default: ''
    },
    // 模块编号
    moduleCode: {
      type: String,
      default: ''
    },
    // 规则编号
    ruleCode: {
      type: String,
      default: ''
    },
    // 使用平台 op-运营平台
    platformType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        validType: 1,
        validTimes: null
      },
      showTimes: false
    };
  },
  watch: {
    'formData': {
      handler(val) {
        this.$emit('change', val);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getRuleInfo();
  },
  methods: {
    /**
     * 获取已有的规则信息
     */
    getRuleInfo() {
      if (!this.ruleCode) {
        return;
      }
      getRuleBaseInfo(this.ruleCode, this.platformType).then(res => {
        this.formData = res;
      });
    },
    onChange(val) {
      if (val === 1) {
        this.showTimes = false;
        this.formData.validTimes = null;
      } else {
        this.showTimes = true;
      }
    }
  }
};
</script>
